<div class="data-table">
	<table #table [ngClass]="{ 'view-360': renderPSView }">
		<thead>
			<tr>
				<th
					class="text-bold text-align-{{ column.attribute['align'] }} align-{{ column.attribute['align'] }} col-id-{{ column.config.id }}"
					*ngFor="let column of headersX; index as i"
					(click)="adjustSort(column.config)"
				>
					<div class="header-box">
						{{ column.formattedValue }}
						<dcr-cell-content [cell]="column"></dcr-cell-content>

						<!-- Info bubble -->
						<icon *ngIf="column.config.infoBubble" type="info-circle" class="info-circle text-14" [tooltip]="infoBubble"></icon>
						<ng-template #infoBubble> <section [innerHTML]="column.config.infoBubble"></section> </ng-template>

						<!-- Sorting -->
						<ng-container *ngIf="sortable && isColumnSortable(column.config)">
							<icon type="sort" *ngIf="sortKey$.value !== column.config.id" class="sort-icon"></icon>
							<icon type="sort-asc" *ngIf="sortKey$.value === column.config.id && sortDirection$.value === SortDirection.ASC" class="sort-icon"></icon>
							<icon type="sort-desc" *ngIf="sortKey$.value === column.config.id && sortDirection$.value === SortDirection.DESC" class="sort-icon"></icon>
						</ng-container>
					</div>
				</th>
			</tr>
		</thead>
		<tbody *ngIf="viewData">
			<tr *ngFor="let row of viewData; index as k">
				<td
					class="align-{{ column.attribute['align'] }} text-align-{{ column.attribute['align'] }} col-id-{{ column.config.id }}"
					*ngFor="let column of headersX; index as i"
				>
					<ng-container *ngIf="viewData[k][i] || viewData[k][i] === 0; else notApplicable">
						<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
						<a
							*ngIf="column.config.id === 'description' && cellsInView && cellsInView[k][2]?.formattedValue; else portfolioAnalyserPageLink"
							[href]="populatePageUrl(cellsInView[k], cellsInView[k][2]?.formattedValue)"
							class="text-bold"
							target="_blank"
							>{{ viewData[k][i] }}
						</a>
						<!-- Used in Model Evaluator app Performance Tab-->
						<ng-template #portfolioAnalyserPageLink>
							<span
								*ngIf="column.config.id === 'modelName' && (tableData?.cells)[k][0]?.config?.id === 'id' && (tableData?.cells)[k][0]?.rawValue; else columnLabel"
								class="hover-underline hover-pointer"
								(click)="onClickPortfolio((tableData?.cells)[k][0]?.rawValue)"
							>
								{{ viewData[k][i] }}
							</span>
						</ng-template>
						<ng-template #columnLabel> {{ viewData[k][i] }} </ng-template>
						<dcr-cell-content [cell]="viewData[k][i]"></dcr-cell-content>
					</ng-container>
				</td>
			</tr>
		</tbody>
	</table>
</div>

<!-- Pagination -->
<div *ngIf="showPagination" class="row">
	<div class="col-24">
		<ac-pagination
			[collectionSize]="dataSource$.value.length"
			[pageSize]="pageSize$.value"
			[page]="currentPage$.value"
			[pageSizeChoices]="pageSizeChoices"
			(pageChange)="currentPage$.next($event)"
			(pageSizeChange)="pageSize$.next($event)"
		>
		</ac-pagination>
	</div>
</div>

<ng-template #notApplicable> <i class="not-applicable">n/a</i> </ng-template>
